import { LayoutWindowBreakpoints } from '../interfaces';
import * as layoutWindowBreakpointsJson from './layout-window-breakpoints.json';

export const layoutWindowBreakpoints: LayoutWindowBreakpoints = layoutWindowBreakpointsJson as LayoutWindowBreakpoints;
